import { render, staticRenderFns } from "./CalendarAsideRestrictions.vue?vue&type=template&id=1c4747ac&scoped=true&"
import script from "./CalendarAsideRestrictions.vue?vue&type=script&lang=js&"
export * from "./CalendarAsideRestrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4747ac",
  null
  
)

export default component.exports